<template>
    <div class="main">
        <div class="topdiv">
            <div class="edgedivleft">
            </div>
            <div class="menudiv">
                <el-menu :router="true" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" background-color="#5297f7"
                    text-color="#fff" active-text-color="#fff">
                    <el-menu-item  index="/homepage">首页</el-menu-item>
                    <el-menu-item  index="/creatpage">创建稿件</el-menu-item>
                    <el-menu-item  index="/manuscriptlistpage">稿件列表</el-menu-item>
                    <el-menu-item  index="/messagepage">我的信息</el-menu-item>
                    <el-menu-item  index="/helpcenterpage">帮助中心</el-menu-item>
                    <el-menu-item v-if="userphone=='17681610714' || userphone=='15827222650'  || userphone=='18672313591'"  index="/realtimeinfo">资讯管理</el-menu-item>
                    <el-submenu index="/changepassword">
                        <template slot="title">账户安全</template>
                        <el-menu-item index="/changepassword">修改密码</el-menu-item>
                        <!-- <el-menu-item @click="changeemail" index="/changeemail">换绑邮箱</el-menu-item> -->
                        <el-menu-item index="/changephone">换绑手机号</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <div  class="edgedivright">
                <div @click="imgClick">
                    <el-avatar  style="cursor: pointer;"
                    :src="imgur">
                </el-avatar>
                </div>
                <el-dropdown @command="handleCommand"
                    style="margin-left:20px;color: #fff;font-weight: bold;cursor: pointer;" size="medium">
                    <span class="el-dropdown-link">
                        {{userName}}<i style="color: #fff;" class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="quit">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="centerdiv">
            <router-view />
        </div>
        <div class="bottomdiv">
            <a target="_blank" href="https://beian.miit.gov.cn">黔ICP备2022003883号-1</a>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                imgur:this.baseUrl.hbjx+"/"+JSON.parse(this.baseUrl.getCookie("userInfo")).headProtraitUrl,
                userName:JSON.parse(this.baseUrl.getCookie("userInfo")).name,
                userphone:JSON.parse(this.baseUrl.getCookie("userInfo")).phone,
            }
        },
        //初始化方法
        mounted() {
            // if (JSON.parse(this.baseUrl.getCookie("userInfo")).headProtraitUrl == undefined) {
            //     this.imgur = 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
            // }else{
            //     this.imgur = this.baseUrl.hbjx+"/"+JSON.parse(this.baseUrl.getCookie("userInfo")).headProtraitUrl
            // }
        },
        //计算属性
        computed:{
            activeIndex(){
                var returnstr='';
                 //首页
                 if (this.$route.path==='/homepage') {
                    returnstr = '/homepage';
                }
                //创建稿件
                if (this.$route.path==='/creatpage' || this.$route.path==='/createpagesuccess') {
                    returnstr = '/creatpage';
                }
                //稿件列表，稿件详情
                if (this.$route.path==='/manuscriptlistpage' || this.$route.path==='/pageInfo'|| this.$route.path==='/editpage') {
                    returnstr = '/manuscriptlistpage';
                }
                //我的信息
                if (this.$route.path==='/messagepage') {
                    returnstr = '/messagepage';
                }
                 //帮助中心
                 if (this.$route.path==='/helpcenterpage') {
                    returnstr = '/helpcenterpage';
                }
                //资讯管理
                if (this.$route.path==='/realtimeinfo') {
                    returnstr = '/realtimeinfo';
                }
                //账户安全
                if (this.$route.path==='/changepassword' || this.$route.path==='/changephone') {
                    returnstr = '/changepassword';
                }
                return returnstr;
            },
        },
        //创建方法
        methods: {
            imgClick(){
                this.$router.push('/messagepage');
            },
            //退出系统
            handleCommand(command) {
                switch (command) {
                    case "quit":
                        this.$confirm("是否确认退出登录?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                            center: 'true'
                        })
                            .then(() => {
                                this.baseUrl.setCookie("userInfo", "", -1);
                                localStorage.removeItem("pageinfo");
                                this.$router.push('/');
                            })
                            .catch(() => { });
                        break;
                }
            }
        },
    }
</script>
<style>
    .main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: rgb(247, 247, 247);
    }
    .topdiv {
        width: 100%;
        height: 62px;
        display: flex;
        justify-content: center;
        background-color: #5297f7;
    }

    .centerdiv {
        width: 1100px;

    }

    .el-submenu__title {
        font-weight: bold;
    }

    .el-menu-item,
    .el-submenu__title {
        font-weight: bold;
    }

    .el-submenu__title i {
        color: #fff;
        font-weight: bold;
    }

    .bottomdiv {
        width: 100%;
        height: 150px;
        background-color: #555;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
    }

    .el-menu.el-menu--horizontal {
        border-bottom: none;
    }

    .el-menu-item {
        font-weight: bold;
    }

    .edgedivleft {
        display: flex;
        height: 100%;
        flex: 1;
    }

    .edgedivright {
        display: flex;
        height: 100%;
        flex: 1;
        justify-content: center;
        align-items: center;
    }

    .menudiv {
        display: flex;
        height: 100%;
        width: 1100px;
        justify-content: center;
    }

    .el-message-box {
        width: 300px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Layout.vue